var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoReintegrosGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 70.2",
    style: {
      enableBackground: "new 0 0 85 70.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M42.5,58.4c-12.8,0-23.3-10.4-23.3-23.3s10.4-23.3,23.3-23.3c12.8,0,23.3,10.4,23.3,23.3S55.3,58.4,42.5,58.4z  M42.5,14.4c-11.4,0-20.7,9.3-20.7,20.7s9.3,20.7,20.7,20.7c11.4,0,20.7-9.3,20.7-20.7S53.9,14.4,42.5,14.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M8.2,35.1c-0.7,0-1.3-0.6-1.3-1.3c0-18.9,15.4-34.3,34.3-34.3c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3 C23.7,2.1,9.5,16.3,9.5,33.8C9.5,34.5,8.9,35.1,8.2,35.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M8.2,36.4c-0.3,0-0.6-0.1-0.8-0.3l-7.5-6.8c-0.5-0.5-0.6-1.3-0.1-1.8c0.5-0.5,1.3-0.6,1.8-0.1l6.7,6l6.8-6 c0.5-0.5,1.3-0.4,1.8,0.1c0.5,0.5,0.4,1.3-0.1,1.8L9,36C8.8,36.3,8.5,36.4,8.2,36.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M43.8,70.6c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3c17.5,0,31.7-14.2,31.7-31.7c0-0.7,0.6-1.3,1.3-1.3 s1.3,0.6,1.3,1.3C78.1,55.2,62.7,70.6,43.8,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M84.3,44.4c-0.3,0-0.6-0.1-0.8-0.3l-6.7-6l-6.7,6c-0.5,0.5-1.3,0.4-1.8-0.1c-0.5-0.5-0.4-1.3,0.1-1.8l7.5-6.8 c0.5-0.4,1.2-0.4,1.7,0l7.5,6.8c0.5,0.5,0.6,1.3,0.1,1.8C85,44.2,84.6,44.4,84.3,44.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M42.7,18.7c0.6,0,1.1,0.6,1.1,1.1V21c2.4,0.2,4.2,1,6.2,2.3c0.3,0.3,0.7,0.7,0.7,1.1c0,0.8-0.6,1.3-1.4,1.3 c-0.2,0-0.5,0-0.8-0.2c-1.6-1.1-3.2-1.8-4.8-2.1v8.9c5.5,1.3,7.9,3.4,7.9,7.1c0,3.9-3.2,6.5-7.8,6.9v2.6c0,0.6-0.6,1.1-1.1,1.1 s-1.1-0.6-1.1-1.1v-2.6c-3-0.2-5.5-1.4-7.9-3.2c-0.3-0.3-0.6-0.7-0.6-1.1c0-0.7,0.6-1.3,1.4-1.3c0.3,0,0.7,0.1,0.8,0.3 c1.9,1.6,3.9,2.6,6.4,3v-9.1c-5.4-1.3-7.8-3.3-7.8-7.1s3.2-6.5,7.7-6.7V20C41.6,19.2,42.2,18.7,42.7,18.7z M41.7,32v-8.6 c-3.1,0.1-4.9,1.9-4.9,4.1C36.8,29.6,37.8,31,41.7,32z M43.9,35.2v8.7c3.1-0.2,5-1.8,5-4.2C48.9,37.6,47.8,36.2,43.9,35.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoReintegrosGris);
export default __webpack_public_path__ + "static/media/iconoReintegrosGris.1ef5121f.svg";
export { ForwardRef as ReactComponent };